<template>
  <div>
    <ul class="legendList">
      <li
        v-for="(legendItem, n) in legendData"
        :key="n"
        :style="{ color: textColors[n] }"
      >
        <div class="legendDotCont">
          <div
            class="legendDot"
            :style="{ backgroundColor: textColors[n] }"
          />
        </div>
        <div class="legendLabel">
          {{ legendItem }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RareGraphLegend',
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      industryCompAndDecimalException: 'industryCompAndDecimalException',
      pre1Sep2019Mode: 'pre1Sep2019Mode',
      textColors: 'fetchTextColors',
    }),
    legendData() {
      let dataToReturn;
      if (this.industryCompAndDecimalException || this.pre1Sep2019Mode) {
        dataToReturn = this.$store.getters.legendData.slice(0, 1);
      } else {
        dataToReturn = this.$store.getters.legendData;
      }
      return dataToReturn;
    },
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .legendList {
     margin-top: 10px;
  }

  .legendDotCont {
    display: inline-block;
    position: relative;
    height: 24px;
    width: 14px;
  }

  .legendDot {
    position: absolute;
    top: 12px;
    display: inline-block;
    height: 14px;
    width: 14px;
    font-size: 1px;
    border-radius: 7px;
  }

  .legendLabel {
    display: inline-block;
    margin-left: 3px;
    height: 24px;
    line-height: 24px;
  }

  ul {
    list-style: none;
    display: inline-block;
    margin-left: 0;
  }

  li {
    display: inline;
    font-family: Europa;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    margin-right: 20px;
    height: 24px;
    line-height: 24px;
    padding: 0;
  }

</style>
